import CustomMask from '@/components/common/CustomMask/index.vue'

export default {
  name: 'PageLoader',
  components: {
    CustomMask
  }
}
